import { render, staticRenderFns } from "./AddContents.vue?vue&type=template&id=5185b80e"
import script from "./AddContents.vue?vue&type=script&lang=js"
export * from "./AddContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports